/**
 * Created by fers on 05.02.16.
 */
/*eslint no-console: 0*/

import PropTypes from 'prop-types';
import BasicEditor from './BasicEditor.react';

interface EditorProps {
    onSuccess?: (...args: unknown[]) => unknown;
    saver: (...args: unknown[]) => unknown;
}

export default class Editor extends BasicEditor<EditorProps> {
    static propTypes = {
        onSuccess: PropTypes.func,
        saver: PropTypes.func.isRequired,
    };

    submitForm = (data) => {
        console.log("Saving", data);

        let defaultValue = null;

        if (this.isCreate()) {
            defaultValue = this.props.metadata.defaultValues(this.props.parent ? this.props.parent : {});
        }

        return Promise.resolve(this.props.saver(this.props.metadata, this.isCreate(), this.props.columns, data)).then((saver) => {
            if (!saver) {
                return;
            }
            return saver.save(data, defaultValue, this.props.columns, this.props.onSuccess ? this.props.onSuccess : this.defaulOnSuccess, this.defaultOnFailure);
        });
    };
}
